<template>
  <pipeline-settings />
</template>

<script>
import PipelineSettings from "@/components/3pl/CRM/PipelineManagement/PipelineSettings";
export default {
  components: {
    PipelineSettings,
  },
};
</script>

<style></style>
